import s from './footer.module.scss';
import logo from '../img/logo.png'

export default function footer() {
    return (
        <div data-aos='fade-left' className={s.container}>
            <div className={s.wrapper}>
                <div className={s.imgWrapper}> <img data-aos='slide-right' src={logo} alt="" /></div>
                <div className={s.textContainer}>
                    <p className={s.primary} >
                        Time is ticking <wbr /> constantly...
                    </p>
                    <p className={s.secondary}>
                        let's overcome it silently.
                    </p>
                    <p className={s.sign}>
                        ~ injamul islam
                    </p>
                </div>
            </div>
        </div>
    )
}
